export const MapConfig = Object.freeze({
    WIDTH: 33554432,
    HEIGHT: 33554432,
    MIN_ZOOM: 9,  // 9
    MAX_ZOOM: 20,
    MAX_NATIVE_ZOOM: 17,
    MIN_GRID_ZOOM: 14,
});
